/**
 * @generated SignedSource<<4e87ed39acecc98ab7fedef7330ae967>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimeRuleFragment$data = {
  readonly notValidAfter: number | null;
  readonly notValidBefore: number | null;
  readonly " $fragmentType": "TimeRuleFragment";
};
export type TimeRuleFragment$key = {
  readonly " $data"?: TimeRuleFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeRuleFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeRuleFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notValidAfter",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notValidBefore",
      "storageKey": null
    }
  ],
  "type": "LiquidDelegationRules",
  "abstractKey": null
};

(node as any).hash = "49ecfdcbd13b05262c929cb6b89d8793";

export default node;
